import { NgModule } from '@angular/core';
import { SuperAdminLayoutComponent } from './super-admin-layout.component';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { RouterModule } from '@angular/router';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { FormsModule } from '@angular/forms';
import { FooterComponent } from '../footer/footer.component';
import { ProfilePreviewModule } from '../_shared/components/profile-preview';
import { TranslateModule } from '@ngx-translate/core';
import { BackgroundModule } from '../_shared/components';

@NgModule({
  declarations: [
    SuperAdminLayoutComponent,
    HeaderComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    NzSelectModule,
    TranslateModule,
    ProfilePreviewModule,
    FormsModule,
    FooterComponent,
    BackgroundModule
  ],
  exports: [SuperAdminLayoutComponent]
})
export class SuperAdminLayoutModule {}
